import { useState, useEffect, useMemo } from "react";

import styled from "styled-components";


import { ImArrowLeft, ImArrowRight } from "react-icons/im";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import GreenButton from "../../../../ui/GreenButton";


const Container = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;


const TdButton = styled.td`
  font-size: 16px;
  font-weight: bold;
  word-break: break-word;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  color: #575757;
  text-align: center;
  &:hover {
    transform: scale(1.1);
      
  }
  @media (max-width: 768px) {
    ${(props) => props.hideOnMobile && "display: none;"}
    display: flex;
    justify-content: center;
    padding: 5px 0;
    font-size: 14px;
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin: 5px 0px;
    padding: 10px 0px;
    &::before {
      content: attr(data-label); /* Exibe o cabeçalho como rótulo no layout de cards */
      font-weight: bold;
      margin-right: 10px;
    }
  }
`;

const Thead = styled.thead`
  @media (max-width: 768px) {
    display: none;
  }
`;

const Tbody = styled.tbody`
  padding-bottom: 25px; 

  @media (max-width: 768px) {
    display: block; /* Torna cada linha um card */
  }
`;

const Tr = styled.tr`
  text-align: center;

  &:hover {
    background-color: #f5f5f5;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    margin-bottom: 10px;
  }
`;

const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;

  @media (max-width: 768px) {
    ${(props) => props.hideOnMobile && "display: none;"}
    display: none; /* Oculta cabeçalhos no layout de cards */
  }
`;

const Td = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    padding: 8px 0;
    width: auto;
    &::before {
      content: attr(data-label);
      font-weight: bold;
      color: #333;
      margin-right: 10px;
    }
  }
`;


const Td3 = styled.td`
  width: 96%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px 0px;
  align-items: center;

  span{
    margin: 0px 5px;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
    text-align: center;
    gap: 15px;
  }

`;

const Input = styled.input`
  width: 500px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
`;

const Button = styled.button`
  cursor: pointer;
  border: none;
  color: black;
  background-color: transparent;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.1);
  }
`;
const Button2 = styled.button`
  padding: 5px 20px;
  background-color: rgba(255, 255, 255, 0.1);
  color: #575757;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  font-size: 22px;
  font-weight: bold;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  white-space: nowrap; /* ❌ impede quebra de linha */
  display: flex;       /* ✅ ativa flexbox */
  align-items: center; /* ✅ alinha verticalmente */
  justify-content: center; /* ✅ centraliza horizontalmente */
  text-align: center;

  transition: transform 0.2s ease, background-color 0.3s ease;
  gap: 5px;
  &:hover {
    transform: scale(1.1);
    background-color: rgba(255, 255, 255, 0.2);
  }

  @media (max-width: 768px) {
    padding: 5px;
    font-size: 14px;
  }
`;
const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  
  span{
    padding: 0px  10px;
  }
`;

const Select = styled.select`
  width: 250px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
  margin-left: 5px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;


const TableWrapper = styled.div`

  overflow: auto;
  border-radius: 7px;
  background: #fff;
  

  max-width: 98%;   /* limite de largura */
  margin: auto;   /* centraliza */
  padding: 12px;/* leve respiro interno */
`;


export const Table = styled.table`
 
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;

  /* (opcionais do seu layout externo) */
  box-shadow: 0 0 2px #ccc;
  border-radius: 7px;
  margin-bottom: 10px;

  /* células padrão */
  th, td {
    padding: 12px 14px;
    font-size: 14px;
    color: #333;
  }

  /* cabeçalho fixo */
  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #fafafa;
    color: #555;
    font-weight: 600;
    text-align: left;
    border-bottom: 1px solid #eee;
  }

  /* listras + hover */
  tbody tr { transition: background 0.15s ease; }
  tbody tr:nth-child(even) { background: #fcfcfc; }
  tbody tr:hover { background: #E5F7EE; }

  /* divisórias e alinhamento */
  tbody td {
    border-bottom: 1px solid #f0f0f0;

  }
  tbody tr:last-child td { border-bottom: 0; }

  /* cantos arredondados */
  thead th:first-child { border-top-left-radius: 5px; }
  thead th:last-child  { border-top-right-radius: 5px; }
  tbody tr:last-child td:first-child { border-bottom-left-radius: 5px; }
  tbody tr:last-child td:last-child  { border-bottom-right-radius: 5px; }

  /* descrição com quebra — sem mudar seu JSX (4ª coluna) */
  tbody td:nth-child(4) {
    max-width: 520px;
    white-space: pre-wrap;
    word-break: break-word;
  }

  @media (max-width: 780px) {
    min-width: 600px; /* força scroll horizontal no mobile */
    th, td { padding: 10px 12px; font-size: 13px; }
  }
`;


const ActionButton = styled.button`
  padding: 8px 12px;
  border-radius: 5px;
  border: 1px solid #ddd;
  background: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: transform .12s ease;
  &:hover { transform: scale(1.03); }
`;


const Grid = ({ listaEquipamento, modalVerEquipamento, modalCadastrarEquipamento, tipoPosse, tipoEquipamento }) => {



  //----------------------------------------CHAMA o MODAL DE EDITAR USUARIO E ACESSOS--------------------------------------------------///

  const handleEdit = (item) => {
    modalVerEquipamento(item);

  };



  //--------------------MONTA OS SELECTS
  const setorUnicos = Array.from(
    new Map(
      listaEquipamento.map(item => [item.COD_DEPARTAMENTO, {
        value: item.COD_DEPARTAMENTO,
        label: item.DESC_DEPARTAMENTO
      }])
    ).values()
  );

  const [filtroSetor, setFiltroSetor] = useState('');




  //---------------------------------------FUNÇÂO DE PESQUISA---------------------------------------------------//

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(listaEquipamento);
  const [tipoSelecionado, setTipoSelecionado] = useState('');
  const [equipamentoSelecionado, setEquipamentoSelecionado] = useState('');


  //Input de pesquisa
  const handleSearch = async (term) => {
    try {
      const filtered = listaEquipamento.filter((user) => {
        const tag = (user.TAG_EQUIPAMENTO || '').toString().toLowerCase();
        const descricao = (user.DESC_TIPO_EQUIPAMENTO || '').toLowerCase();
        const setor = (user.DESC_DEPARTAMENTO || '').toLowerCase();
        const posse = (user.DESC_TIPO_POSSE || '').toLowerCase();

        const passaFiltroPesquisa =
          tag.includes(term.toLowerCase()) ||
          descricao.includes(term.toLowerCase()) ||
          setor.includes(term.toLowerCase()) ||
          posse.includes(term.toLowerCase());

        const passaFiltroTipoPosse =
          tipoSelecionado === '' || user.ID_TIPO_POSSE === parseInt(tipoSelecionado, 10);

        const passaFiltroTipoEquipamento =
          equipamentoSelecionado === '' || user.ID_TIPO_EQUIPAMENTO === parseInt(equipamentoSelecionado, 10);

        const passaFiltroSetor = filtroSetor === '' || user.COD_DEPARTAMENTO === parseInt(filtroSetor, 10);



        return passaFiltroPesquisa && passaFiltroTipoPosse && passaFiltroTipoEquipamento && passaFiltroSetor;
      });

      setFilteredUsers(filtered);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    }

    setCurrentPage(1);
  };


  useEffect(() => {
    handleSearch(searchTerm);
  }, [searchTerm, listaEquipamento, tipoSelecionado, equipamentoSelecionado, filtroSetor]);

  //---------------------------------------------ORDENAÇÂO DA PAGINA-----------------------------------------------------------------//
  //Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);


  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);

  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//

  //Paginação
  // Defina a quantidade de itens por página conforme necessário
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  // Função para ir para a próxima página
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  // Função para ir para a página anterior
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    setCurrentPage(1); // Reseta para a primeira página ao ordenar
  };

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };

  //---------------------------------------MODAL CADASTRAR USUARIOS---------------------------------------------------//
  // Chama o modal de cadastrar usuários
  const handleCadastrarEquipamento = () => {
    modalCadastrarEquipamento()
  };




  const exportarParaExcel = (dados) => {
    // Mapeia os campos desejados
    const dataFormatada = dados.map((item) => ({
      'TAG': item.TAG_EQUIPAMENTO,
      'Tipo': item.DESC_TIPO_EQUIPAMENTO,
      'Setor': item.DESC_DEPARTAMENTO,
      'Objeto de Custo': item.DESC_OBJETOCUSTO,
      'Posse': item.DESC_TIPO_POSSE,
      'Marca/Modelo': item.DESC_MARCA_MODELO,
      'Número de Série': item.NUMERO_SERIE ?? '',
      'Responsável': item.COD_USUARIO_RESPONSAVEL,
      'Contrato': item.CONTRATO ?? '',
      'Observação': item.OBSERVACAO ?? '',
      'Situação': item.DESC_SITUACAO,
      'Data Início': item.DATA_INICIO,
      'Data Fim': item.DATA_FIM
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataFormatada);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Equipamentos');

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, `Equipamentos_Central_TI_${new Date().toLocaleString("pt-BR")}.xlsx`);
  };

  return (



    <Container>
      <Td3 >


        <GreenButton onClick={handleCadastrarEquipamento}>
          Cadastrar Equipamento
        </GreenButton>

        <GreenButton onClick={() => exportarParaExcel(listaEquipamento)}>
          Exportar para excel
        </GreenButton>


      </Td3>

      <Td3 >

        <Input
          type="text"
          placeholder="Pesquisar..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <Select
          value={tipoSelecionado}
          onChange={(e) => setTipoSelecionado(e.target.value)}
        >
          <option value="">Todos os tipos</option>
          {tipoPosse.map((tipo) => (
            <option key={tipo.ID_TIPO} value={tipo.ID_TIPO}>
              {tipo.DESC_TIPO_POSSE}

            </option>
          ))}
        </Select>

        <Select
          value={equipamentoSelecionado}
          onChange={(e) => setEquipamentoSelecionado(e.target.value)}
        >
          <option value="">Todos os equipamentos</option>
          {tipoEquipamento.map((tipo) => (
            <option key={tipo.ID_TIPO} value={tipo.ID_TIPO}>
              {tipo.DESC_TIPO_EQUIPAMENTO}

            </option>
          ))}
        </Select>
        <Select value={filtroSetor} onChange={(e) => setFiltroSetor(e.target.value)}>
          <option value="">Todos os setores</option>
          {setorUnicos.map((setor, idx) => (
            <option key={idx} value={setor.value}>{setor.label}</option>
          ))}
        </Select>

        <Select value={itemsPerPage} onChange={(e) => {
          const value = e.target.value === "all" ? sortedData.length : parseInt(e.target.value);
          setItemsPerPage(value);
          setCurrentPage(1); // Resetar para a primeira página sempre que mudar
        }}>
          <option value={10}>10 por página</option>
          <option value={50}>50 por página</option>
          <option value={100}>100 por página</option>
          <option value="all">Todos</option>
        </Select>




        <Div>
          <Button onClick={handlePrevPage} disabled={currentPage === 1}>
            <ImArrowLeft size={20} />
          </Button>
          <span>Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
          <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
            <ImArrowRight size={20} />
          </Button>
        </Div>




      </Td3>


      {currentItems.length === 0 ? (
        <Tr>
          <Td colSpan={4} style={{ textAlign: 'center', padding: '20px', fontSize: '18px' }}>
            Nenhum equipamento encontrado.
          </Td>
        </Tr>
      ) : (
        <TableWrapper>
          <Table>
            <thead>
              <tr>
                <th onClick={() => onColumnClick("TAG_EQUIPAMENTO")} className={getSortClass("TAG_EQUIPAMENTO")}>
                  TAG {getSortIcon("TAG_EQUIPAMENTO")}
                </th>

                <th onClick={() => onColumnClick("DESC_TIPO_EQUIPAMENTO")} className={getSortClass("DESC_TIPO_EQUIPAMENTO")}>
                  Tipo {getSortIcon("DESC_TIPO_EQUIPAMENTO")}
                </th>

                <th onClick={() => onColumnClick("DESC_DEPARTAMENTO")} className={getSortClass("DESC_DEPARTAMENTO")}>
                  Setor: {getSortIcon("DESC_DEPARTAMENTO")}
                </th>

                <th onClick={() => onColumnClick("DESC_TIPO_POSSEA")} className={getSortClass("DESC_TIPO_POSSE")}>
                  Posse {getSortIcon("DESC_TIPO_POSSE")}
                </th>


                <th></th>
              </tr>
            </thead>

            <tbody>
              {currentItems.map((item, i) => (
                <tr key={i}>
                  <td><strong>{item.TAG_EQUIPAMENTO}</strong></td>
                  <td>{item.DESC_TIPO_EQUIPAMENTO}</td>
                  <td >{item.DESC_DEPARTAMENTO}</td>
                  <td >{item.DESC_TIPO_POSSE}</td>



                  <td>
                    <ActionButton onClick={() => handleEdit(item)}>
                      Ver informações
                    </ActionButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableWrapper>

      )}


    </Container>
  );
};


export default Grid;
